module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/pages/go/go-page-root.component.html
// module id = ../../../../../src/app/pages/go/go-page-root.component.html
// module chunks = 0